import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/term-semesters', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/term-semesters', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/term-semesters/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/term-semesters/${data.ac_term_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/term-semesters/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getSubProgram = (Options = {}) => {
  return httpClient
    .get('/api/term-semesters/sub-programs')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getAcYear = (Options = {}) => {
  return httpClient
    .get('/api/term-semesters/academic-years', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTermOrder = data => {
  return httpClient
    .get(`/api/term-semesters/term-orders/${data.acYearId}/${data.acpsId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const switchTerm = data => {
  return httpClient
    .post(`/api/term-semesters/term-switch/${data.ac_term_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const copyTerm = data => {
  return httpClient
    .post('/api/term-semesters/copy-term', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMainProgram = (Options = {}) => {
  return httpClient
    .get('/api/term-semesters/main-programs')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getAcYear,
  getSubProgram,
  getTermOrder,
  switchTerm,
  copyTerm,
  getMainProgram
}
